module.exports = __webpack_public_path__ + "static/img/UTM老师_张雪婷.213cb6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTM/UTM老师_张雪婷.png
// module id = 130y
// module chunks = 0